import Vue from 'vue';
import Vuex from 'vuex';

import { BACK_STAGE_URL } from '@/utils/constants';
import dashboard from './dashboard';
import member from './member';
import menu from './menu';
import orders from './orders';
import reports from './reports';
import setting from './setting';
import store from './store';
import user from './user';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    dashboard,
    member,
    menu,
    orders,
    reports,
    setting,
    store,
    user,
  },
  state: {
    isSidebarCollapsed: false,
  },
  mutations: {
    collapseSiderbar(state, isCollapsed) {
      state.isSidebarCollapsed = isCollapsed;
    },
  },
  getters: {
    isProduction() {
      return window.location.origin === BACK_STAGE_URL.PRODUCTION;
    },
  },
});
